export enum TemplateTableColumnSize {
  Name = 55,
  UpdatedAt = 29,
  Status = 16,
}

export default TemplateTableColumnSize;
